import PropTypes from 'prop-types';

// material-ui
import { styled } from '@mui/material/styles';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import {
    SmartphoneTwoTone,
    WifiTetheringTwoTone,
    LocalGasStationTwoTone,
    HealthAndSafetyTwoTone,
    SchoolTwoTone,
    PaymentTwoTone
} from '@mui/icons-material';

import urlFriendlyName from 'utils/urlFriendlyName';
import { useNavigate } from 'react-router-dom';
import { LOAD_DEPARTMENT_PRODUCTS, PATCH_BILL_PAY_RATES } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';

const getIconByCategory = (name) => {
    switch (name) {
        case 'Airtime':
            return <SmartphoneTwoTone fontSize="large" />;
        case 'Broadband':
            return <WifiTetheringTwoTone fontSize="large" />;
        case 'Fuel':
            return <LocalGasStationTwoTone fontSize="large" />;
        case 'Insurance':
            return <HealthAndSafetyTwoTone fontSize="large" />;
        case 'Tuition Fees':
            return <SchoolTwoTone fontSize="large" />;
        case 'Utility Bills':
            return <PaymentTwoTone fontSize="large" />;
        default:
            return null;
    }
};

// styles
const IconWrapper = styled('div')({
    position: 'absolute',
    left: '-17px',
    bottom: '-27px',
    color: '#fff',
    transform: 'rotate(25deg)',
    '&> svg': {
        width: '100px',
        height: '100px',
        opacity: '0.35'
    }
});

// =============================|| BILLER DEPARTMENT CARD ||============================= //

const BillerDepartmentCard = ({ department, billers }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const billPayDepartmentRatesTable = useSelector((state) => state.settings.billPayDepartmentRatesTable);
    const defaultBillPayUSDConvert = useSelector((state) => state.settings.defaultBillPayUSDConvert);
    const defaultBillPayZWLConvert = useSelector((state) => state.settings.defaultBillPayZWLConvert);

    const getBackgroundColorByCategory = (name) => {
        switch (name) {
            case 'Airtime':
                return theme.palette.primary.dark;
            case 'Broadband':
                return theme.palette.orange.dark;
            case 'Fuel':
                return theme.palette.secondary.dark;
            case 'Insurance':
                return theme.palette.info.dark;
            case 'Tuition Fees':
                return theme.palette.success.dark;
            case 'Utility Bills':
                return theme.palette.error.dark;
            default:
                return null;
        }
    };

    const navigate = useNavigate();
    const primaryIcon = getIconByCategory(department);
    const backgroundColor = getBackgroundColorByCategory(department);
    const handleClick = (department) => {
        dispatch({
            type: LOAD_DEPARTMENT_PRODUCTS,
            departmentBillers: billers
        });

        // Filter the array based on the given department name
        const filteredData = billPayDepartmentRatesTable.filter((item) => item.department === department);

        // Check if there is a match and retrieve the zwl and usd values
        if (filteredData.length > 0) {
            const zwlValue = filteredData[0].zwl;
            const usdValue = filteredData[0].usd;
            dispatch({
                type: PATCH_BILL_PAY_RATES,
                // Update BillPay Settings
                billPayZWLConvert: zwlValue,
                billPayUSDConvert: usdValue
            });
        } else {
            dispatch({
                type: PATCH_BILL_PAY_RATES,
                // Update BillPay Settings
                billPayZWLConvert: defaultBillPayZWLConvert,
                billPayUSDConvert: defaultBillPayUSDConvert
            });
        }

        // Navigate to a different page with the parameter
        navigate(`/services/zimbabwe/${urlFriendlyName(department)}`);
    };
    return (
        <Card
            onClick={() => handleClick(department)}
            sx={{
                background: backgroundColor,
                position: 'relative',
                color: '#fff',
                transition: 'box-shadow 0.3s',
                '&:hover': {
                    boxShadow: '0px 3px 15px rgba(0, 0, 0, 0.1)'
                },
                cursor: 'pointer'
            }}
        >
            <CardContent>
                <IconWrapper>{primaryIcon}</IconWrapper>
                <Grid container direction="column" justifyContent="center" alignItems="center" spacing={1}>
                    <Grid item sm={12}>
                        <Typography variant="h3" align="center" color="inherit">
                            {department}
                        </Typography>
                    </Grid>
                    {/* <Grid item sm={12}>
                        <Typography variant="body1" align="center" color="inherit">
                            {department}
                        </Typography>
                    </Grid> */}
                </Grid>
            </CardContent>
        </Card>
    );
};

BillerDepartmentCard.propTypes = {
    department: PropTypes.string,
    billers: PropTypes.object
};

export default BillerDepartmentCard;
